import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import { Form, Formik } from 'formik';
import * as FormikControls from '../../libs/Formik';
import { SurveyContext } from '../surveycontext';
import { ValidationSchema } from '../validationschema';
import SurveyResult from './surveyresult';

class SurveyForm extends PureComponent {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.getFieldClassName = this.getFieldClassName.bind(this);
    }

    state = {
        submitting: false
    }
    
    onSubmit = (values) => {
        this.setState({ 'submitting': true });
        this.context.submitSurveyForm(values).then((data) => {
            this.setState({ 'submitting': false });
        });
    }

    getFieldClassName = (field) => {
        if (!this.form || !this.form.state) {
            return '';
        }
        
        const error = this.form.state.errors[field];
        const initialValue = this.form.initialValues[field];
        const currentValue = this.form.state.values[field];
        if (error != null) {
            return 'error';
        }

        if (currentValue == null) {
            return null;
        }

        if (initialValue != currentValue) {
            return 'success';
        }

        return '';
    }


    render() {
        const { } = this.context;
        const { submitting } = this.state;
        const buttonText = 'Versturen';
        const buttonClassName = `ui button primary${(submitting ? ' loading' : '')}`;
        return (
            <div className='ui segment surveyform'>
                <Formik onSubmit={this.onSubmit}
                    ref={node => (this.form = node)}
                    initialValues={{
                        Company: '',
                        Firstname: '',
                        Insertion: '',
                        Surname: ''
                    }}
                    validationSchema={ValidationSchema}
                    render={({ setFieldValue }) => (
                        <Form className='ui form'>
                            <SurveyResult />

                            <h3>Vul hier uw gegevens in </h3>
                            <div className="inline fields">
                                <label className="four wide field">
                                    Bedrijf
                         </label>

                                <FormikControls.Input
                                    name='Company'
                                    className={'eight wide field ' + this.getFieldClassName('Company')}
                                    onChange={setFieldValue}
                                    placeholder='Bedrijf'
                                />
                            </div>
                            <div className="inline fields">
                                <label className="four wide field">
                                    Naam
                         </label>

                                <FormikControls.Input
                                    name='Firstname'
                                    className={'three wide field ' + this.getFieldClassName('Firstname')}
                                    onChange={setFieldValue}
                                    placeholder='Voornaam'
                                />
                                <FormikControls.Input
                                    name='Insertion'
                                    className={'one wide field ' + this.getFieldClassName('Insertion')}
                                    onChange={setFieldValue}
                                    placeholder='Tussenvoegsel'
                                />
                                <FormikControls.Input
                                    name='Surname'
                                    className={'four wide field ' + this.getFieldClassName('Surname')}
                                    onChange={setFieldValue}
                                    placeholder='Achternaam'
                                />
                            </div>

                            <div className="inline fields">
                                <label className="four wide field">
                                    E-mail
                         </label>

                                <FormikControls.Input
                                    name='Email'
                                    className={'eight wide field ' + this.getFieldClassName('Email')}
                                    onChange={setFieldValue}
                                    placeholder='E-mail'
                                />
                            </div>
                            <div className="inline fields">
                                <label className="four wide field">
                                    Telefoonnummer
                         </label>

                                <FormikControls.Input
                                    name='Phonenumber'
                                    className={'eight wide field ' + this.getFieldClassName('Phonenumber')}
                                    onChange={setFieldValue}
                                    placeholder='Telefoonnummer'
                                />
                            </div>
                            <button className={buttonClassName} disabled={submitting} type='submit'>{buttonText}</button>
                        </Form>
                    )} />
            </div>
        );
    }
}
SurveyForm.contextType = SurveyContext;
export default SurveyForm;